export interface Employee {
  Id: number;
  FirstName: string;
  LastName: string;
  Tag: number;
  EmployeeType: number; // 1 = Sewer, 2 = Trimmer
  CreateDate?: Date;
  InactiveDate?: Date | null;
}

export interface EmployeeInput {
  FirstName: string;
  LastName: string;
  Tag: number;
  EmployeeType: number;
}

export const EmployeeType = {
  Sewer: 1,
  Trimmer: 2,
} as const;
export type EmployeeType = typeof EmployeeType[keyof typeof EmployeeType];
